export const clientesData = {
  ES: {
    title: "Nuestros Clientes",
    subtitle: "Proyectos de gran altura",
    clientes: [
      { id: 1, logo: "/assets/imgs/clientes/1.jpg" },
      { id: 2, logo: "/assets/imgs/clientes/2.png" },
      { id: 3, logo: "/assets/imgs/clientes/3.jpg" },
      { id: 4, logo: "/assets/imgs/clientes/4.png" },
      { id: 5, logo: "/assets/imgs/clientes/5.jpg" },
      { id: 6, logo: "/assets/imgs/clientes/6.jpg" },
      { id: 7, logo: "/assets/imgs/clientes/7.png" },
      { id: 8, logo: "/assets/imgs/clientes/8.svg" },
      { id: 9, logo: "/assets/imgs/clientes/9.png" },
      { id: 10, logo: "/assets/imgs/clientes/10.png" },
      { id: 11, logo: "/assets/imgs/clientes/11.svg" },
      { id: 12, logo: "/assets/imgs/clientes/12.png" },
      { id: 13, logo: "/assets/imgs/clientes/13.png" },
      { id: 14, logo: "/assets/imgs/clientes/14.jpg" }
    ]
  },
  EN: {
    title: "Our Clients",
    subtitle: "High-rise Projects",
    clientes: [
      { id: 1, logo: "/assets/imgs/clientes/homedepot.png" },
      { id: 2, logo: "/assets/imgs/clientes/bestwestern.png" },
      { id: 3, logo: "/assets/imgs/clientes/holidayinn.png" },
      { id: 4, logo: "/assets/imgs/clientes/bestday.png" },
      { id: 5, logo: "/assets/imgs/clientes/hollyburn.png" },
      { id: 6, logo: "/assets/imgs/clientes/homedepot.png" },
      { id: 7, logo: "/assets/imgs/clientes/bestwestern.png" },
      { id: 8, logo: "/assets/imgs/clientes/holidayinn.png" },
      { id: 9, logo: "/assets/imgs/clientes/bestday.png" },
      { id: 10, logo: "/assets/imgs/clientes/hollyburn.png" }
    ]
  }
};
